import React from 'react';

import IconTooltip, { IconTooltipType } from '../../iconTooltip';

import './field.scss';

interface IFieldProps {
  className?: string;
  label: string;
  value?: string;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

const Field: React.FC<IFieldProps> = ({
  className,
  label,
  value = '',
  onChange,
  placeholder,
  error,
  disabled = false,
}) => {
  const fieldClass = `field ${disabled ? 'disabled' : ''} ${className} ${error ? 'error' : ''}`;

  return (
    <p className={fieldClass}>
      <label className="field-label">{label}</label>

      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className="field-input"
      />

      {error && (
        <IconTooltip
          iconType={IconTooltipType.INFO}
          className="negative"
          tooltipId={`field-tooltip-${className}`}
          tooltipContent={error}
        />
      )}
    </p>
  );
};

export default Field;
